import FieldErrorUi from 'common/components/core/FieldErrors/ui/FieldErrorUi'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { FontProps } from 'common/utils/styleUtilsNew'
import React, { forwardRef } from 'react'
import { BookingCalendarStepsSwitcher } from '../booking-calendar-steps-switcher'
import { CalendarStep, CalendarStepProps } from '../calendar-step'
import {
  CommonCalendarButtonUi,
  CommonCalendarButtonWrapper,
} from '../calendar-step/ui/common-calendar-button-ui'
import { BookingCalendarSteps } from '../constants'
import {
  CommonBookingCalendarContainerUi,
  CommonBookingCalendarWrapperUi,
} from '../ui/common-calendar-container-ui'

interface CommonBookingPaidCalendarProps
  extends Omit<CalendarStepProps, 'entity' | 'questions'> {
  onPrevStepClick?: () => void
  calendarStepErrors?: string[]
  isEventLoading?: boolean
  isDisabled?: boolean

  activeStep: BookingCalendarSteps
  formStepChildren: React.ReactNode
  formStepButton: React.ReactNode
  entity: BookingPaidCalendarInterface
}

export const CommonBookingPaidCalendar = forwardRef<
  HTMLDivElement,
  CommonBookingPaidCalendarProps & FontProps
>(
  (
    {
      availabilitySlots,
      selectedDate,
      selectedMonth,
      onMonthSelect,
      onDateSelect,
      selectedTimeSlot,
      onTimeSlotSelect,
      selectedTimeZone,
      onTimeZoneSelect,
      selectedLocationId,
      onLocationSelect,
      event,
      isEventLoading,
      activeStep,
      entity,
      formStepChildren,
      onNextStepClick,
      onPrevStepClick,
      calendarStepErrors,
      isMobile,
      fontFamily,
      fontSize,
      fontStyle,
      fontWeight,
      letterSpacing,
      mobileFontFamily,
      mobileFontSize,
      mobileFontStyle,
      mobileFontWeight,
      mobileLetterSpacing,
      formStepButton,
    },
    ref,
  ) => {
    const commonStyles = {
      color: entity.color,
      mobileColor: entity.mobileColor,
      mobilePadding: entity.mobilePadding,
      mobileMargin: entity.mobileMargin,
      fontFamily,
      fontSize,
      fontStyle,
      fontWeight,
      letterSpacing,
      mobileFontFamily,
      mobileFontSize,
      mobileFontStyle,
      mobileFontWeight,
      mobileLetterSpacing,
    }
    return (
      <CommonBookingCalendarWrapperUi ref={ref}>
        <CommonBookingCalendarContainerUi
          padding={entity.padding}
          margin={entity.margin}
          isThankYouStep={false}
          isDateSelected={!!selectedDate}
          {...commonStyles}
        >
          <BookingCalendarStepsSwitcher
            onPrevStepClick={onPrevStepClick}
            onNextStepClick={onNextStepClick}
            activeStep={activeStep}
            entity={entity}
            {...commonStyles}
          />
          {activeStep === BookingCalendarSteps.CalendarStep ? (
            <>
              <CalendarStep
                availabilitySlots={availabilitySlots}
                selectedDate={selectedDate}
                selectedMonth={selectedMonth}
                onMonthSelect={onMonthSelect}
                onDateSelect={onDateSelect}
                selectedTimeSlot={selectedTimeSlot}
                onTimeSlotSelect={onTimeSlotSelect}
                selectedTimeZone={selectedTimeZone}
                onTimeZoneSelect={onTimeZoneSelect}
                selectedLocationId={selectedLocationId}
                onLocationSelect={onLocationSelect}
                event={event}
                isEventLoading={isEventLoading}
                entity={entity}
                isMobile={isMobile}
                {...commonStyles}
              />
              <CommonCalendarButtonWrapper>
                <CommonCalendarButtonUi
                  backgroundColor={entity.selectedSlotBackgroundColor}
                  onClick={onNextStepClick}
                  {...commonStyles}
                >
                  {entity.nextStepButtonText}
                </CommonCalendarButtonUi>
                {calendarStepErrors?.map(error => (
                  <FieldErrorUi key={error}>{error}</FieldErrorUi>
                ))}
              </CommonCalendarButtonWrapper>
            </>
          ) : (
            <>
              {formStepChildren}
              {formStepButton}
            </>
          )}
        </CommonBookingCalendarContainerUi>
      </CommonBookingCalendarWrapperUi>
    )
  },
)
